module.exports = __webpack_public_path__ + "static/super-admin-withdrawal-form-d977dd539887c82aadba5343231df6be.png";